import { ProductSelection } from './ProductSelection';
import { AddToCart } from "../../snippets"

export function ProductAddToCartBar({
  selectedVariant,
  quantity,
  isMobileViewport,
  elementInView,
  needsSelection,
  optionChanges,
  smoothScrollTo,
  forceSoldOut,
}) {
  const selectionClasses = isMobileViewport && elementInView ? 'h-0 !max-h-0' : '';

  return (
    <div
      className={`fixed bottom-0 left-0 z-10 w-full max-w-full motion-reduce:transition-max-height duration-500 ease-in-out h-auto max-h-14 overflow-hidden ${selectionClasses}`}
    >
      <div className="flex-1 bg-white ">
        <AddToCart
          isPdp
          quantity={quantity}
          selectedVariant={selectedVariant}
          needsSelection={needsSelection}
          optionChanges={optionChanges}
          isMobileViewport={isMobileViewport}
          smoothScrollTo={smoothScrollTo}
          forceSoldOut={forceSoldOut}
        />
      </div>
    </div>
  );
}

ProductAddToCartBar.displayName = 'ProductAddToCartBar';
